import { render } from "./Verify2FA.vue?vue&type=template&id=4367eb24"
import script from "./Verify2FA.vue?vue&type=script&lang=js"
export * from "./Verify2FA.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__